import React, { useContext, useEffect, useState } from "react";
import ModalCustom from "../components/common/ModalCustom";
import { Col, Row } from "reactstrap";
import ButtonIcon from "../components/common/ButtonIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserLock } from "@fortawesome/free-solid-svg-icons";
import AppContext from "../context/Context";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

const TwoFactorImportant = () => {
  let { loginUserDetails } = useContext(AppContext);
  const [is2faModelOpen, setIs2faModelOpen] = useState(false);
  const history = useHistory();
  const isApiPlusExist =
    loginUserDetails?.is_partner == "1" &&
    loginUserDetails.user_type?.toLowerCase() !== "User".toLowerCase()
      ? sessionStorage.getItem("api_plus_plus")
        ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
        : false
      : false;

  useEffect(() => {
    if (loginUserDetails?.is_2fa_enabled == "no" || isApiPlusExist) {
      if (window.location.href.includes("/profile")) {
        if (isApiPlusExist) {
          history?.push(`${process.env.PUBLIC_URL}/authentication/login`);
        } else {
          setIs2faModelOpen(true);
        }
      } else {
        if (isApiPlusExist) {
          history?.push(`${process.env.PUBLIC_URL}/authentication/login`);
        } else {
          setIs2faModelOpen(true);
        }
        if (loginUserDetails?.is_partner == "0") {
          history?.push(`${process.env.PUBLIC_URL}/admin/settings/profile`);
        } else {
          history?.push(`${process.env.PUBLIC_URL}/user/settings/profile`);
        }
      }
    }
  }, [window.location.href]);

  return (
    <>
      <ModalCustom
        title={"Enable Two-Factor Authentication"}
        openPopup={is2faModelOpen}
        setOpenPopup={setIs2faModelOpen}
        size="md"
        centered
        fade={false}
        backdrop={"static"}
        isHeaderCloseBtn={false}
        keyboard={false}
      >
        <Row>
          <Col>
            <h6 className="text-danger">
              Please enable two-factor authentication to ensure your security
              and after you are able to use API Portal.
            </h6>
          </Col>
        </Row>
        <Row>
          <Col>
            <ButtonIcon
              color="outline-success"
              size="sm"
              icon="Sync"
              className="ml-1 mt-lg-2 mt-sm-2 mt-md-2 mb-2"
              iconClassName="fs--2"
              onClick={() => {
                setIs2faModelOpen(false);
              }}
            >
              <FontAwesomeIcon
                style={{ marginRight: "5px" }}
                icon={faUserLock}
              />
              Enable
            </ButtonIcon>
          </Col>
        </Row>
      </ModalCustom>
    </>
  );
};

export default TwoFactorImportant;
